// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2gkgr","footer":"Form_footer__1BpcG"};